module.exports = __webpack_public_path__ + "bed-bubble-friend-enough.51406190.png";